import{Locale as a}from"../../../locale/Locale.enum.mjs";const e={csv:new Map([[a.ja,"CSV"]]),pdf:new Map([[a.ja,"PDF"]]),csvForFileImport:new Map([[a.ja,"CSV(データ取込用)"]]),log:new Map([[a.ja,"ログ"]])};export{e as fileTypeNameConfig};
